import { styled } from "@stitches/react";
import { Box } from "../../components/primitives";

export const Container = styled(Box, {
  minHeight: "100vh",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  backgroundColor: "$grayLight",
  fontFamily: "$body",
});

export const LoginBox = styled(Box, {
  backgroundColor: "white",
  padding: "2rem",
  borderRadius: "8px",
  boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
  width: "500px",
});

export const FormStyled = styled("form", {
  display: "flex",
  flexDirection: "column",
  gap: 20,
  alignItems: "center",
  justifyContent: "center",
});

export const Title = styled("h2", {
  color: "$primary",
  marginBottom: "1.5rem",
  textAlign: "center",
});
